<svg sh-icon [name]="iconName$ | async"></svg>
